import { io, Socket } from "socket.io-client";

let socket: Socket | null = null;

export const initSocket = () => {
    if (!socket) {
        socket = io(process.env.REACT_APP_BASE_URL, {
            //   transports: ["websocket", "polling"],
            withCredentials: true,
            reconnection: true
        });

        // debug listeners
        socket.on("connect", () => {
            console.log("✅ Connected to socket:", socket?.id);
        });

        socket.on("connect_error", (err: any) => {
            console.error("❌ connect_error:", err.message);
        });

        socket.on("disconnect", (reason: any) => {
            console.warn("⚠️ Disconnected:", reason);
        });
    }

    return socket;
};

export const getSocket = () => socket;
